import api from ".";
import { IMetaFunction } from "../types/meta_function";
import cookiesModifier from "../utils/cookies";

export const getMetaFunctions = async (type: string) => {
    try {
        const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`meta-functions/${type}`);

        return res.data as IMetaFunction[];
    } catch (error) {
        throw error;
    }
}